import React, { useMemo } from 'react';
import Link from 'next/link';

const ModuleProductDetailDescription = ({ product }) => {
    const { product_store, short_description, shippings, taxes } = product.attributes;

    const vendor = useMemo(() => {
        return product_store && product_store.data && product_store.data.attributes
            ? product_store.data.attributes.title
            : null;
    }, [product_store]);

    const deliveryTime = useMemo(() => {
        return shippings?.data?.attributes?.delivery_time || null;
    }, [shippings]);

    return (
        <div className="ps-product__container">
            <div className="ps-product__desc">
                {vendor && (
                    <p>
                        Verkauft von:
                        <Link href={'/shop'}>
                            <strong> {vendor}</strong>
                        </Link>
                    </p>
                )}

                <ul className="ps-list--dot">
                    {short_description && (
                        <div
                            className="short-description"
                            dangerouslySetInnerHTML={{ __html: short_description }}
                        />
                    )}
                </ul>
            </div>
        </div>
    );
};

export default ModuleProductDetailDescription;
